/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import { Link, useNavigate } from 'react-router-dom'
import { useEffect, useMemo, useRef } from 'react'
import { useLayout } from '../../core'
import { Header } from './Header'
import { Navbar } from './Navbar'
import { applyMenuFilter, clearMenuFilter } from '../sidebar/menuFilter'
import BrandLogo from '../../../assets/media/uMart-logo.png'

function headerSearchShortcutLabel(): string {
  if (typeof navigator === 'undefined') return 'Ctrl+K'
  const platform = (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData
    ?.platform
  const haystack = `${platform || ''} ${navigator.platform || ''} ${navigator.userAgent || ''}`
  return /Mac|iPhone|iPad|iPod/i.test(haystack) ? '⌘K' : 'Ctrl+K'
}

export function HeaderWrapper() {
  const { config, classes } = useLayout()
  const navigate = useNavigate()
  const searchRef = useRef<HTMLInputElement | null>(null)
  const shortcutLabel = useMemo(() => headerSearchShortcutLabel(), [])

  useEffect(() => {
    const handleShortcut = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault()
        searchRef.current?.focus()
      }
    }
    document.addEventListener('keydown', handleShortcut)
    return () => document.removeEventListener('keydown', handleShortcut)
  }, [])

  if (!config.app?.header?.display) {
    return null
  }

  const goToFirstMatch = () => {
    const firstVisibleLink = document.querySelector<HTMLAnchorElement>(
      '#kt_app_sidebar .menu-item:not([style*="display: none"]) a[href]'
    )
    if (firstVisibleLink) {
      const href = firstVisibleLink.getAttribute('href')
      if (href) navigate(href)
    }
  }

  return (
    <div id="kt_app_header" className="app-header">
      <div
        id="kt_app_header_container"
        className={clsx(
          'app-container d-flex align-items-center justify-content-between w-100 flex-lg-grow-1',
          classes.headerContainer.join(' '),
          config.app?.header?.default?.containerClass,
        )}
      >
        {config.app.sidebar?.display && (
          <>
            <div
              className="d-flex align-items-center d-lg-none ms-n2 me-2"
              title="Show sidebar menu"
            >
              <div
                className="btn btn-icon btn-active-color-primary w-35px h-35px"
                id="kt_app_sidebar_mobile_toggle"
              >
                <i className="bi bi-list fs-2" aria-hidden="true" />
              </div>
            </div>
          </>
        )}

        <Link
          to="/dashboard"
          aria-label="UMart Admin"
          className="admin-header-brand d-flex align-items-center flex-shrink-0 gap-2 me-auto"
        >
          <img alt="" src={BrandLogo} className="h-30px" />
        </Link>

        <div className="admin-header-search d-none d-md-flex mx-3">
          <i className="bi bi-search" aria-hidden="true" />
          <input
            ref={searchRef}
            type="text"
            placeholder="Search orders, customers, products, reports..."
            aria-label="Search menu"
            onChange={(event) => applyMenuFilter(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                goToFirstMatch()
              } else if (event.key === 'Escape') {
                event.currentTarget.value = ''
                clearMenuFilter()
                event.currentTarget.blur()
              }
            }}
          />
          <kbd aria-hidden="true">{shortcutLabel}</kbd>
        </div>

        <div
          id="kt_app_header_wrapper"
          className="d-flex align-items-stretch justify-content-end ms-auto"
        >
          {config.app.header.default?.content === 'menu' &&
            config.app.header.default.menu?.display && (
              <div
                className="app-header-menu app-header-mobile-drawer align-items-stretch"
                data-kt-drawer="true"
                data-kt-drawer-name="app-header-menu"
                data-kt-drawer-activate="{default: true, lg: false}"
                data-kt-drawer-overlay="true"
                data-kt-drawer-width="225px"
                data-kt-drawer-direction="end"
                data-kt-drawer-toggle="#kt_app_header_menu_toggle"
                data-kt-swapper="true"
                data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
                data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}"
              >
                <Header />
              </div>
            )}
          <Navbar />
        </div>
      </div>
    </div>
  )
}
